import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import PropTypes from 'prop-types';

const PrimaryTextField = ({
  size = 'small',
  sx = {},
  fontSize = '0.875rem',
  backgroundColor = '#FFFFFF',
  borderColor = '#DDDFE3',
  borderRadius = '4px',
  ...props
}) => {
  const baseStyles = {
    '& .MuiOutlinedInput-root': {
      borderRadius,
      fontSize,
      backgroundColor,
      border: `1px solid ${borderColor}`,
      '& .MuiInputBase-input': {
        py: 0.75,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      marginRight: 0,
      fontFamily: 'IBM Plex Sans, sans-serif',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '0.8125rem',
      lineHeight: '100%',
      letterSpacing: '-0.15px',
      color: '#4A5565',
    },
  };

  return (
    <MuiTextField
      size={size}
      sx={{
        ...baseStyles,
        ...sx,
      }}
      {...props}
    />
  );
};

PrimaryTextField.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  sx: PropTypes.object,
  fontSize: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
};

export default PrimaryTextField;

